export const AWS_S3_URL = "https://am-group-deal-room.s3.amazonaws.com";
